const translations = {
  'filters.levels': 'Niveis',
  'filters.selectLevel': 'Seleção de {{level}}',
  'filters.destination': 'Destino',
  'filters.selectDestinations': 'Seleção de destinos',
  'filters.selectPlaces': 'Seleção de locais'
}

export default translations
